module.exports = __webpack_public_path__ + "img/firstM.e219e9dc.png";